var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { Card, Button, Table } from 'antd';
import { Bar } from 'react-chartjs-2';
import { useQuery } from '@tanstack/react-query';
import LineChartFilter from '../../dashboard/components/filter/line-date-chart-filter';
import { fetchMaleLikesPerMonth, fetchMaleLikesPerMonthDetail } from '../../cores/api/api-dashboard';
import { formatCountNumber } from '../../utils/format-data';
import ChartDataLabels from 'chartjs-plugin-datalabels';
const GENDER_OPTIONS = [{
        value: 'male',
        label: '男性'
    }, {
        value: 'female',
        label: '女性'
    }];
export const ChartMaleLikeAverage = () => {
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState({
        mode: 'month',
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        gender: 'male'
    }), _useState4 = _slicedToArray(_useState3, 2), filters = _useState4[0], setFilters = _useState4[1];
    const handleGenderChange = g => {
        setFilters(prev => _objectSpread(_objectSpread({}, prev), {}, {
            gender: g
        }));
    };
    const _useQuery = useQuery({
        queryKey: ['male-like-used', filters],
        suspense: true,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            const year = filters.year, month = filters.month, gender = filters.gender, mode = filters.mode, year_from = filters.year_from, year_to = filters.year_to;
            const res = mode === 'month' && month ? yield fetchMaleLikesPerMonthDetail({
                year,
                month,
                gender
            }) : mode === 'range' && year_from != null && year_to != null ? yield fetchMaleLikesPerMonth({
                year_from,
                year_to,
                gender
            }) : yield fetchMaleLikesPerMonth({
                year,
                gender
            });
            if (!(res === null || res === void 0 ? void 0 : res.success) || !(res === null || res === void 0 ? void 0 : res.data)) {
                return {
                    labels: [],
                    totals: [],
                    values: [],
                    userCounts: []
                };
            }
            const apiData = res.data;
            const labels = Object.keys(apiData);
            const totals = Object.values(apiData).map(item => { var _a; return (_a = item.total) !== null && _a !== void 0 ? _a : 0; });
            const values = Object.values(apiData).map(item => {
                var _a, _b;
                const total = (_a = item.total) !== null && _a !== void 0 ? _a : 0;
                const userCount = (_b = item.user_count) !== null && _b !== void 0 ? _b : 0;
                return userCount > 0 ? Math.round(total / userCount * 100) / 100 : 0;
            });
            const userCounts = Object.values(apiData).map(item => { var _a; return (_a = item.user_count) !== null && _a !== void 0 ? _a : 0; });
            return {
                labels,
                totals,
                values,
                userCounts
            };
        }),
        staleTime: 1000 * 60 * 5
    }), data = _useQuery.data;
    const chartState = data !== null && data !== void 0 ? data : {
        labels: [],
        totals: [],
        values: [],
        userCounts: []
    };
    const handleFilterChange = value => {
        setFilters(prev => _objectSpread(_objectSpread({}, prev), value));
    };
    const chartData = {
        labels: chartState.labels.map(l => {
            const d = new Date(l);
            if (filters.mode !== 'month' || !filters.month) {
                return `${d.getFullYear()}/${d.getMonth() + 1}`;
            }
            return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
        }),
        datasets: [{
                label: '平均いいね数',
                data: chartState.values,
                backgroundColor: '#2f80ed',
                borderRadius: 4,
                barThickness: 40
            }]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: context => {
                        const index = context.dataIndex;
                        const total = chartState.totals[index];
                        const avg = chartState.values[index];
                        return [`Total: ${formatCountNumber(total)}`];
                    }
                }
            },
            datalabels: {
                anchor: 'center',
                align: 'center',
                color: '#000',
                font: {
                    size: 12,
                    weight: 'bold'
                },
                formatter: (_, context) => {
                    const index = context.dataIndex;
                    const total = chartState.totals[index];
                    const userCount = chartState.userCounts[index];
                    if (!total || !userCount)
                        return '';
                    const avg = chartState.values[index];
                    return avg.toFixed(1);
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    autoSkip: false,
                    maxRotation: filters.month ? 45 : 0,
                    minRotation: filters.month ? 45 : 0
                }
            },
            y: {
                beginAtZero: true,
                grid: {
                    color: '#f0f0f0'
                },
                ticks: {
                    callback: value => value.toFixed(1)
                }
            }
        }
    };
    const tableColumns = [{
            title: '期間',
            dataIndex: 'label'
        }, {
            title: 'いいね使用数',
            dataIndex: 'total',
            render: v => formatCountNumber(v)
        }, {
            title: '使用ユーザー数',
            dataIndex: 'userCount',
            render: v => formatCountNumber(v)
        }, {
            title: '平均いいね数',
            dataIndex: 'value'
        }];
    const tableData = chartState.labels.map((label, index) => {
        var _a, _b, _c;
        return ({
            key: label,
            label,
            total: (_a = chartState.totals[index]) !== null && _a !== void 0 ? _a : 0,
            value: (_b = chartState.values[index]) !== null && _b !== void 0 ? _b : 0,
            userCount: (_c = chartState.userCounts[index]) !== null && _c !== void 0 ? _c : 0
        });
    });
    const genderLabel = filters.gender === 'female' ? '女性' : '男性';
    return /*#__PURE__*/ React.createElement(Card, {
        title: `1ヶ月あたりのいいね平均使用数(${genderLabel})`,
        extra: /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-4"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center gap-3"
        }, GENDER_OPTIONS.map(g => /*#__PURE__*/ React.createElement(Button, {
            key: g.value,
            onClick: () => handleGenderChange(g.value),
            className: filters.gender === g.value ? '!bg-[#f0c52a36]' : ''
        }, g.label))), /*#__PURE__*/ React.createElement(LineChartFilter, {
            enableYearRange: true,
            onChange: handleFilterChange
        }), /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('chart'),
            className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
        }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('table'),
            className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
        }, "\u8868")))
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 350
        }
    }, /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: options,
        plugins: [ChartDataLabels]
    })) : /*#__PURE__*/ React.createElement(Table, {
        rowKey: "key",
        columns: tableColumns,
        dataSource: tableData,
        pagination: false,
        scroll: {
            y: 350
        },
        locale: {
            emptyText: 'データがありません'
        }
    }));
};
